import React, { useState } from 'react';

 function Error() {
 
  const [spinner,updatespinner] = useState(0);

    return (
      <>
               
    <div class="error-page-area default-padding">
        <div class="container">
            <div class="row">
                <div class="col-md-8 col-md-offset-2 text-center content">
                    <h1>404</h1>
                    <h2>Sorry Page Was Not Found!</h2>
                    <p>
                        The page you are looking is not available or has been removed. Try going to Home Page by using the button below.
                    </p>
                    <a class="btn btn-dark effect btn-md" href="#">Back To Home</a>
                </div>
            </div>
        </div>
    </div>
     </>
   )
}

export default Error
